export const DATE_FORMAT = 'yyyy/MM/dd';
export const DATE_PATTERN = /^\d{4}\/\d{2}\/\d{2}$/;
